/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：管理対象のAPI
 *
 * 作成者：2021/11/29 ノア）賀
 * 最終修正者：2021/11/29 ノア）賀
 *
 */
import { apiClient } from '@/store/apis/apiClient'
import config from '@/config/config'
import {
  ManagementTargetData,
  MasterGetParam,
  ReallyOutputPostParam,
  FileDownloadResponse,
  AlertListSearchInfo,
  AlertDataData
} from '@/models'

/**
 * 管理対象一覧を取得する。
 *
 * @async
 * @param {MasterGetParam} reqParams パラメータ
 * @returns {Promise<ManagementTargetData>} 管理対象
 */
export async function getManagementTargetData(reqParams: MasterGetParam): Promise<ManagementTargetData> {
  const res = await apiClient.post(config.api.getManagementTargetData, reqParams)

  return res.data.data as ManagementTargetData
}

/**
 * 管理対象一覧CSVダウンロード
 *
 * @async
 * @param {MasterGetParam} reqParams パラメータ
 * @returns {Promise<FileDownloadResponse>} 管理対象
 */
export async function managementTargetDataDownload(reqParams: MasterGetParam): Promise<FileDownloadResponse> {
  const res = await apiClient.post(config.api.managementTargetDataDownload, reqParams, { responseType: 'blob' })

  return res as unknown as FileDownloadResponse
}

/**
 * 管理対象実績出力CSVダウンロード
 *
 * @async
 * @param {ReallyOutputPostParam} reqParams パラメータ
 * @returns {Promise<FileDownloadResponse>} 管理対象
 */
export async function ManagementTargetHistoryDownload(reqParams: ReallyOutputPostParam): Promise<FileDownloadResponse> {
  const res = await apiClient.post(config.api.managementTargetHistoryDownload, reqParams, { responseType: 'blob' })

  return res as unknown as FileDownloadResponse
}

/**
 * アラーム一覧を取得する。
 *
 * @async
 * @returns {Promise<any>} アラーム
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getAlarmData(): Promise<any> {
  const res = await apiClient.get(config.api.getAlarmData)

  return res.data.data
}

/**
 * 受信回数アラートリスト
 *
 * @async
 * @param {AlertListSearchInfo} reqParams パラメータ
 * @returns {Promise<AlertDataData>} アラート
 */
export async function getAlertListData(reqParams: AlertListSearchInfo): Promise<AlertDataData> {
  const res = await apiClient.post(config.api.getAlertListData, reqParams)

  return res.data.data as AlertDataData
}
